import { Component } from '@angular/core';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { LABELS } from '../../constants/labels.const';

@Component({
  selector: 'ev-not-found',
  imports: [PageHeaderComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  readonly labels = LABELS.notFound;
}
